<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
  style="max-width:98.7vw;width:100%;overflow-y: hidden!important;">
  @for (slide of BannerUrls | async; track slide) {
    <div ngxSlickItem class="slide">
      <a [href]="documentUrlsMap[slide.url] |async" (click)="webtrekk_click(slide.urlLink)" target="_blank">
        <img [src]="baseUrl + slide.url" alt="" class="imgWidth">
      </a>
    </div>
  }
</ngx-slick-carousel>